import React, { forwardRef, useId } from 'react';
import SVGInline from 'components/SVGInline/SVGInline';
import { AriaHint, OptionName } from 'components/Pages/Settings/PageSettingsCommon.css';
import translate from 'utils/fnTranslate';
import icons from 'style';
import { RadioButtonGroup } from './ButtonRadioGroup.css';

interface ButtonRadioValue {
    name: string;
    label: string;
    description?: string;
}

interface ButtonRadioType {
    name: string;
    value: ButtonRadioValue;
    initialValue?: string;
    onChange?: (value: any) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLLabelElement>) => void;
    checked: boolean;
    isTabStop: boolean;
    index: number;
    ignoreFocusKey?: boolean;
    isHorizontal?: boolean;
    style?: any;
}

const ButtonRadioGroupFocusable = forwardRef<HTMLLabelElement, ButtonRadioType>(
    ({ name, value, onChange, onKeyDown, checked, isTabStop, style, isHorizontal }, ref) => {
        const hintId = useId();
        const hasHint = name === 'language';

        return (
            <RadioButtonGroup
                ref={ref}
                tabIndex={isTabStop ? 0 : -1}
                role="radio"
                aria-checked={checked}
                onKeyDown={onKeyDown}
                isHorizontal={isHorizontal}
                aria-label={value.description ? translate(value.description) : undefined}
                aria-describedby={hasHint ? hintId : undefined}
            >
                <OptionName style={style}>{value.label}</OptionName>
                {hasHint && (
                    <AriaHint id={hintId} aria-hidden>
                        {translate('ARIA_HINT_RELOADS_APP')}
                    </AriaHint>
                )}
                <input
                    data-test-id={'header-account-languagebuttons'}
                    type="radio"
                    id={`${value.name}-${name}`}
                    name={name}
                    value={value.name}
                    onChange={(e) => onChange(e)}
                    checked={checked}
                    tabIndex={-1}
                    aria-hidden
                />
                <SVGInline className={'check-mark-icon'} svg={icons.checkMarkIcon} />
            </RadioButtonGroup>
        );
    }
);

ButtonRadioGroupFocusable.displayName = 'ButtonRadioGroupFocusable';

export default ButtonRadioGroupFocusable;
